export default class SaveProposalContentError extends Error {
}
